/* eslint-disable react/prop-types */

import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import { SDKanbanContext } from 'context/Context';
import currentUserAvatar from 'assets/img/team/3.jpg';

import {
  labels,
  attachments, comments,
  activities
} from 'data/sdKanban';
import { sdKanbanReducer } from 'reducers/sdKanbanReducer';

const SDKanbanProvider = ({ boardItems, children }) => {
  console.log("Kanban Provider Data = ", boardItems);

  const initData = {
    members: [],
    labels: labels,
    attachments: attachments,
    kanbanItems: boardItems,
    comments: comments,
    activities: activities,
    kanbanModal: {
      show: false,
      modalContent: {}
    }
  };

  console.log("Kanban Init Data", initData);
  const currentUser = {
    name: 'Emma',
    avatarSrc: currentUserAvatar,
    profileLink: '/user/profile',
    institutionLink: '#!'
  };

  const [kanbanState, kanbanDispatch] = useReducer(sdKanbanReducer, initData);

  console.log("SDKanbanProvider kanbanState", initData, kanbanState);

  return (
    <SDKanbanContext.Provider
      value={{ kanbanState, kanbanDispatch, currentUser }}
    >
      {children}
    </SDKanbanContext.Provider>
  );
};

SDKanbanProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default SDKanbanProvider;
